import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import EventsManager from "../utils/EventsManager";
import CustomEvents from "../utils/CustomEvents";

gsap.registerPlugin(ScrollTrigger);

export default class ProcessModule extends Module {
  constructor(options) {
    super(options);

    this.DOMEl = options.element;

    this.canAnim = false;
    this.animComplete = false;

    this.titleContent = this.DOMEl.querySelector(".process-module__wrapper-heading");

    this.ProcessGrid = this.DOMEl.querySelector(".process-module__steps");
    this.processCards = this.DOMEl.querySelectorAll(".process-module__step-content");
    this.processNumber = this.DOMEl.querySelectorAll(".process-module__step-number");

    this.videos = this.DOMEl.querySelectorAll('.inner-img video');

    this.timeline = gsap.timeline().pause();

    this.init();
  }

  init() {
    if (this.titleContent) this.timeline.to(this.titleContent, {
      css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'},
      duration: 0.7,
      ease: "power2.out"
    });

    ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: () => {
        this.timeline.play();
      },
      onEnterBack: () => {
        this.timeline.play();
      }
    });

    this.processCards.forEach(card => {
      gsap.timeline({
        scrollTrigger: {
          trigger: card,
          scrub: true,
          start: "top bottom",
          end: "top center"
        }
      }).from(card, {'opacity': '0', 'transform': 'translate3d(0, 15px, 0)'})
        .to(card, {'opacity': '1', 'transform': 'translate3d(0, 0, 0)'});
    });

    this.processNumber.forEach(number => {
      gsap.timeline({
        scrollTrigger: {
          trigger: number,
          scrub: true,
          start: "top bottom-=200",
          end: "top top"
        }
      }).from(number, {'height': '0'})
        .to(number, {'height': '100%'});
    });

    if (this.videos)
    {
      this.videos.forEach(video =>{
        video.muted = true;
        video.controls = false;
        video.autoplay = true;
        video.loop = true;
        video.play();
      });
    }

  }
}
